import React from 'react';

export default function OccupationsHeader() {
  return (
    <h1 className="mt-8 text-center text-2xl leading-8 text-column-gray-500 font-semibold">
      Please select your occupation.
    </h1>
  );
}
